'use client';

import React from 'react';
import { SectionTitle, SectionTitleProps } from './SectionTitle';
import { SectionSubtitle } from './SectionSubtitle';
import styled from '@benzinga/themetron';

export interface SectionHeaderProps extends SectionTitleProps {
  bordered?: boolean;
  className?: string;
  level?: number;
  subtitle?: string;
  title?: React.ReactElement | string;
  subtitleTinted?: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  bordered,
  className,
  level = 3,
  subtitle,
  subtitleTinted = true,
  title,
  ...props
}) => {
  return (
    <SectionHeaderContainer className={bordered ? `${className} bordered` : className}>
      {title ? (
        <SectionTitle level={level} {...props}>
          {title}
        </SectionTitle>
      ) : null}
      {subtitle ? (
        <SectionSubtitle className="section-subtitle" tinted={subtitleTinted}>
          {subtitle}
        </SectionSubtitle>
      ) : null}
    </SectionHeaderContainer>
  );
};

export const SectionHeaderContainer = styled.div`
  margin-bottom: 12px;
  .section-title {
    font-size: ${({ theme }) => theme.fontSize['2xl']};
  }
  &.bordered {
    border-bottom: solid 1px ${({ theme }) => theme.colorPalette.neutral500};
    margin: 4px 0;
    padding: 4px 0;
  }
`;
